export default __webpack_public_path__ + "static/SR China - FSSC 22000 - Certificate-d3324fa661c7fe656a21c15cb6d76c7a.pdf";